import { isAdmin } from '../admin/utils/isAdmin.js'

/**
 * Modules soumis à permission (miroir de App\Security\ModuleAccess côté API).
 * La sécurité réelle est côté serveur ; ceci pilote l'affichage (nav + routes).
 */
export const MODULES = [
  { key: 'prospects', label: 'Prospects (et devis, contrats, factures)' },
  { key: 'immobilier', label: 'Immobilier' },
  { key: 'communication', label: 'Communication' },
  { key: 'france_travail', label: 'Candidats France Travail' },
  { key: 'projects_auto', label: 'Projets auto' },
]

/** Vrai si l'utilisateur a accès au module (les admins ont tout). */
export const hasModule = (user, key) =>
  isAdmin(user) || (Array.isArray(user?.moduleAccess) && user.moduleAccess.includes(key))
